/**
 * Returns an array of page numbers and ellipsis markers for pagination UI.
 * e.g. [1, 2, 3, 4, 5, '...', 2425]
 *
 * @param {"full"|"compact"|"minimal"} mode
 *   - full: desktop window
 *   - compact: tablet — at most 3 page numbers
 *   - minimal: phone — no page buttons (prev/next + page label only)
 */
export function getVisiblePages(currentPage, totalPages, mode = "full") {
  if (!totalPages || totalPages < 1) return [1];

  if (mode === "minimal") {
    return [];
  }

  if (mode === "compact") {
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentPage <= 1) {
      return [1, "...", totalPages];
    }

    if (currentPage >= totalPages) {
      return [1, "...", totalPages];
    }

    if (currentPage === 2) {
      return [1, 2, "...", totalPages];
    }

    if (currentPage === totalPages - 1) {
      return [1, "...", totalPages - 1, totalPages];
    }

    return [1, "...", currentPage, "...", totalPages];
  }

  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const window = new Set([1, totalPages]);

  if (currentPage <= 5) {
    for (let i = 1; i <= 5; i++) window.add(i);
  } else if (currentPage >= totalPages - 4) {
    for (let i = totalPages - 4; i <= totalPages; i++) window.add(i);
  } else {
    window.add(currentPage - 1);
    window.add(currentPage);
    window.add(currentPage + 1);
  }

  const sorted = [...window].sort((a, b) => a - b);
  const result = [];

  for (let i = 0; i < sorted.length; i++) {
    if (i > 0 && sorted[i] - sorted[i - 1] > 1) {
      result.push("...");
    }
    result.push(sorted[i]);
  }

  return result;
}

export function formatResultCount(value) {
  return Number(value).toLocaleString();
}
